import appIsReady from './app-is-ready.ts'
import loginRequired from './login-required.ts'
import defaultSubroute from './default-subroute.ts'
import isBusinessCorrect from './is-business-correct.ts'
import checkAccessLevel from './check-access-level.ts'
import checkAccessLevelPermission from './check-access-level-permission.ts'
import trackPage from './track-page.ts'
import restrictedBySubscription from './restricted-by-subscription.ts'
import setRoutes from './set-routes.ts'
import versionCheck from './version-check.ts'
import reloadPage from './reload-page.ts'
import turnTrackerCheckInMode from './turn-tracker-check-in-mode.ts'

import { useLogger } from '@booksy-com/vue-tools'
const logger = useLogger('router.guards.index')

export function registerGuards (router) {
  logger.debug('registering router guards')

  router.beforeEach(appIsReady)

  router.beforeEach(defaultSubroute)

  router.beforeEach(loginRequired)

  router.beforeEach(isBusinessCorrect)

  router.beforeEach(checkAccessLevelPermission)

  router.beforeEach(checkAccessLevel)

  // access to router is required to send analytics
  router.beforeEach(trackPage.bind(router))

  router.beforeEach(turnTrackerCheckInMode)

  router.beforeEach(restrictedBySubscription)

  router.beforeEach(setRoutes)

  router.beforeEach(reloadPage)

  router.afterEach(versionCheck)
}
